/**
 * Appends the current page path to AWIN clickref params for click-source tracking.
 * Example: /products/kijimea-k53-advance → clickref …sl_products_kijimea-k53-advance
 */
(function () {
  var SELECTOR = 'a[href*="awin1.com/cread.php"], [data-nested-link][href*="awin1.com/cread.php"]';

  function getPagePathSlug() {
    return window.location.pathname
      .replace(/^\/+|\/+$/g, '')
      .toLowerCase()
      .replace(/\//g, '_')
      .replace(/[^a-z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function updateAwinLink(el) {
    var href = el.getAttribute('href');
    if (!href || href.indexOf('awin1.com/cread.php') === -1) return;

    var slug = getPagePathSlug();
    if (!slug) return;

    try {
      var url = new URL(href, window.location.origin);
      var clickref = url.searchParams.get('clickref');
      if (!clickref) return;

      // Cut everything after the first "sl-" / "sl_", then append "_" + page path
      var m = clickref.match(/(^|-)sl[-_]/);
      if (!m) return;

      var newClickref = clickref.substring(0, m.index + m[0].length - 1) + '_' + slug;
      if (clickref === newClickref) return;

      url.searchParams.set('clickref', newClickref);
      el.setAttribute('href', url.toString());
    } catch (e) {}
  }

  function run(root) {
    if (root.matches && root.matches(SELECTOR)) updateAwinLink(root);
    if (root.querySelectorAll) {
      root.querySelectorAll(SELECTOR).forEach(updateAwinLink);
    }
  }

  function init() {
    run(document);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mu) {
        if (mu.type === 'childList') {
          mu.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) run(node);
          });
        } else if (mu.type === 'attributes') {
          updateAwinLink(mu.target);
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href'],
    });
  }

  if (document.body) init();
  else document.addEventListener('DOMContentLoaded', init);
})();
